import styles from "./ActorCard.module.scss"
import {useNavigate} from "react-router-dom";
import {ROUTES} from "../../../../constants/routes";

type Props = {
  actorId: number
  fullName: string
  description: string
  image: string
}

const ActorCard = ({ actorId, fullName, description, image }: Props) => {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper} onClick={() => navigate(`${ROUTES.ACTORS}/${actorId}`)}>
      <img
        width={130}
        height={130}
        className={styles.image}
        src={image ? image : ""}
        alt="#"
      />
      <div className={styles.textWrapper}>
        <h3 className={styles.fullName}>{fullName}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  )
}

export default ActorCard
